import { useQuery } from "@tanstack/react-query";
import {
  ActivitiesOptionsParams,
  ActivityOptionsResponse,
  fetchActivitiesOptions
} from "PFCore/services/activities";
import { QueryOptions } from "PFTypes/request_options";

import { activitiesKeys } from "./query_keys";

export const useActivitiesOptions = <TData = ActivityOptionsResponse>(
  params: ActivitiesOptionsParams,
  options: QueryOptions<ActivityOptionsResponse, any, TData> = {}
) =>
  useQuery<ActivityOptionsResponse, any, TData>({
    queryKey: activitiesKeys.options(params),
    queryFn: () => fetchActivitiesOptions(params),
    ...options
  });
